/* Definiciones del FEMO para la pantalla (Fase 2b). Deben coincidir con api/routes/ocupacional/femoSchema.js:
   los mismos identificadores de regiones del examen físico y los mismos catálogos. */
export const INSTITUCIONES = ['MSP', 'IESS', 'ISSFA', 'ISSPOL'];
export const SANGRE = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
export const LATERALIDAD = ['DERECHO', 'IZQUIERDO', 'AMBIDIESTRO'];

/* Regiones del examen físico (bloque F): identificador = número + letra del formulario oficial. */
export const REGIONES = [
  ['1', 'Piel', [['1a', 'Cicatrices'], ['1b', 'Piel y faneras']]],
  ['2', 'Ojos', [['2a', 'Párpados'], ['2b', 'Conjuntivas'], ['2c', 'Pupilas'], ['2d', 'Córnea'], ['2e', 'Motilidad']]],
  ['3', 'Oído', [['3a', 'C. auditivo externo'], ['3b', 'Pabellón'], ['3c', 'Tímpanos']]],
  ['4', 'Oro faringe', [['4a', 'Labios'], ['4b', 'Lengua'], ['4c', 'Faringe'], ['4d', 'Amígdalas'], ['4e', 'Dentadura']]],
  ['5', 'Nariz', [['5a', 'Tabique'], ['5b', 'Cornetes'], ['5c', 'Mucosas'], ['5d', 'Senos paranasales']]],
  ['6', 'Cuello', [['6a', 'Tiroides / masas'], ['6b', 'Movilidad']]],
  ['7', 'Tórax', [['7a', 'Mamas'], ['7b', 'Corazón']]],
  ['8', 'Tórax', [['8a', 'Pulmones'], ['8b', 'Corazón'], ['8c', 'Parrilla costal']]],
  ['9', 'Abdomen', [['9a', 'Vísceras'], ['9b', 'Pared abdominal']]],
  ['10', 'Columna', [['10a', 'Flexibilidad'], ['10b', 'Desviación'], ['10c', 'Dolor']]],
  ['11', 'Pelvis', [['11a', 'Pelvis'], ['11b', 'Genitales']]],
  ['12', 'Extremidades', [['12a', 'Vascular'], ['12b', 'Miembros superiores'], ['12c', 'Miembros inferiores']]],
  ['13', 'Neurológico', [['13a', 'Fuerza'], ['13b', 'Sensibilidad'], ['13c', 'Marcha'], ['13d', 'Reflejos']]],
];

export const BLOQUES = [
  ['a', 'Datos del establecimiento y del trabajador'], ['b', 'Motivo de consulta'], ['c', 'Antecedentes personales'], ['d', 'Enfermedad o problema actual'],
  ['e', 'Constantes vitales y antropometría'], ['f', 'Examen físico regional'], ['g', 'Factores de riesgo del trabajo actual'],
  ['h', 'Actividad laboral, incidentes, accidentes y enfermedades ocupacionales'], ['i', 'Actividades extralaborales'], ['j', 'Resultados de exámenes'],
  ['k', 'Diagnóstico'], ['l', 'Aptitud médica para el trabajo'], ['m', 'Recomendaciones y/o tratamiento'], ['n', 'Retiro'], ['o', 'Datos del profesional'],
];

const consumo = () => ({ no_consume: false, tiempo: '', cantidad: '', ex: false, abstinencia: '' });

/** Formulario vacío con todos los campos (así ningún control queda sin valor). */
export const base = () => ({
  a: { institucion: '', archivo: '', prioritaria: { embarazada: false, discapacidad: false, catastrofica: false, adulto_mayor: false }, sexo: '', fecha_nac: '', sangre: '', lateralidad: '' },
  b: { fecha_reintegro: '', observacion: '' },
  c: {
    clinicos: '', familiares: '', transfusion: '', hormonal: { v: '', cual: '' },
    gineco: { fum: '', gestas: '', partos: '', cesareas: '', abortos: '', planif: { v: '', cual: '' }, examenes: [] },
    masculino: { examenes: [], planif: { v: '', cual: '' } },
    consumo: { tabaco: consumo(), alcohol: consumo(), otras: { ...consumo(), cual: '' }, observacion: '' },
    estilo: { actividad: false, cual: '', tiempo: '' }, medicacion: { habitual: false, cual: '', cantidad: '' },
  },
  d: { descripcion: '' },
  e: { temperatura: '', pa: '', fc: '', fr: '', spo2: '', peso: '', talla: '', perimetro: '' },
  f: { hallazgos: {}, observacion: '' },
  g: { actividades: Array.from({ length: 7 }, () => ''), riesgos: {}, medidas: '' },
  h: { filas: [] }, i: { filas: [], descripcion: '' }, j: { filas: [], observaciones: '' }, k: { sin_patologia: false, filas: [] },
  l: { aptitud: '', limitaciones: { personales: false, adaptativas: false, restrictivas: false }, observaciones: '' },
  m: { descripcion: '' }, n: { realiza: '', relacionada: '', observacion: '' },
});

const esObj = v => v && typeof v === 'object' && !Array.isArray(v);
/** Mezcla lo guardado sobre el formulario vacío. Lo guardado manda; null se vuelve texto vacío. */
export function fusionar(b, s) {
  if (!esObj(b)) return s == null ? b : s;
  const r = { ...b };
  if (!esObj(s)) return r;
  Object.keys(s).forEach(k => {
    if (k.startsWith('_')) return;
    const v = s[k];
    if (v == null) r[k] = Array.isArray(b[k]) ? b[k] : (esObj(b[k]) ? b[k] : '');
    else if (esObj(b[k]) && esObj(v)) r[k] = fusionar(b[k], v);
    else if (k === 'riesgos' || k === 'hallazgos') r[k] = { ...v };
    else r[k] = v;
  });
  return r;
}

/** Copia con un valor cambiado en `ruta` (arreglo de claves). */
export function setIn(o, ruta, valor) {
  if (!ruta.length) return valor;
  const [k, ...resto] = ruta;
  return { ...o, [k]: setIn(o[k] == null ? {} : o[k], resto, valor) };
}

export const imcDe = (peso, talla) => (peso > 0 && talla > 0 ? Math.round((peso / Math.pow(talla / 100, 2)) * 10) / 10 : null);

/** «RUIZ PEREZ» -> ['RUIZ', 'PEREZ'] (primero y resto). */
export function nombresDe(texto) {
  const p = String(texto || '').trim().split(/\s+/).filter(Boolean);
  return [p[0] || '', p.slice(1).join(' ')];
}

/* ───────────── Constantes vitales: formato de entrada y semáforo ─────────────
   Los rangos (mín–máx) son los MISMOS que valida el servidor: fuera de ellos casi siempre es un error de digitación.
   El semáforo (bajo / normal / alto) es referencial para adultos y NO reemplaza el criterio médico. */
export const RANGOS = {
  temperatura: [30, 45, 'Temperatura: entre 30 y 45 °C.'],
  fc: [20, 250, 'Frecuencia cardiaca: entre 20 y 250 lat/min.'],
  fr: [4, 80, 'Frecuencia respiratoria: entre 4 y 80 por minuto.'],
  spo2: [50, 100, 'Saturación de oxígeno: entre 50 y 100 %.'],
  peso: [2, 400, 'Peso: entre 2 y 400 kg.'],
  talla: [40, 250, 'Talla: entre 40 y 250 cm.'],
  perimetro: [20, 250, 'Perímetro abdominal: entre 20 y 250 cm.'],
};
export const PA_LIMITES = { sis: [50, 300], dia: [30, 200] };

/** Cómo se escribe cada campo: enteros = dígitos que caben; dec = decimales permitidos. */
export const VITALES = [
  { k: 'temperatura', label: 'Temperatura', unidad: '°C', icono: 'temp', ph: '36.5', ref: 'Normal 36.0 – 37.5 °C', ayuda: 'Escriba 365 y queda 36.5', mod: 'decimal' },
  { k: 'pa', label: 'Presión arterial', unidad: 'mmHg', icono: 'pa', ph: '120/80', ref: 'Normal menor de 120/80', ayuda: 'Escriba 12080 y queda 120/80', mod: 'numeric' },
  { k: 'fc', label: 'Frecuencia cardiaca', unidad: 'lat/min', icono: 'fc', ph: '72', ref: 'Normal 60 – 100', ayuda: 'Solo números', mod: 'numeric' },
  { k: 'fr', label: 'Frecuencia respiratoria', unidad: 'resp/min', icono: 'fr', ph: '16', ref: 'Normal 12 – 20', ayuda: 'Solo números', mod: 'numeric' },
  { k: 'spo2', label: 'Saturación de oxígeno', unidad: '%', icono: 'spo2', ph: '98', ref: 'Normal 95 – 100 %', ayuda: 'Solo números', mod: 'numeric' },
  { k: 'peso', label: 'Peso', unidad: 'kg', icono: 'peso', ph: '70.5', ref: 'Un decimal', ayuda: 'Ej. 70.5', mod: 'decimal' },
  { k: 'talla', label: 'Talla', unidad: 'cm', icono: 'talla', ph: '170', ref: 'En centímetros', ayuda: 'Ej. 170 (no 1.70)', mod: 'numeric' },
  { k: 'perimetro', label: 'Perímetro abdominal', unidad: 'cm', icono: 'cintura', ph: '85', ref: 'Un decimal', ayuda: 'Medido a nivel del ombligo', mod: 'decimal' },
];

const soloDigitos = (t, max) => String(t == null ? '' : t).replace(/\D/g, '').slice(0, max);
/** Decimal con coma o punto: `enteros` dígitos antes y `dec` después del punto. */
function decimal(t, enteros, dec) {
  let s = String(t == null ? '' : t).replace(',', '.').replace(/[^\d.]/g, '');
  const i = s.indexOf('.');
  if (i >= 0) s = s.slice(0, i + 1) + s.slice(i + 1).replace(/\./g, '');
  let [e, d] = s.split('.');
  e = e.slice(0, enteros);
  return d === undefined ? e : e + '.' + d.slice(0, dec);
}

/** Presión arterial: se escribe solo con números y la barra se pone sola (12080 → 120/80, 9060 → 90/60). */
function presion(nuevo, previo, borrando) {
  const t = String(nuevo == null ? '' : nuevo).replace(/[^\d/]/g, '');
  const barra = t.indexOf('/');
  if (barra >= 0) {
    const sis = t.slice(0, barra).replace(/\//g, '').slice(0, 3);
    const dia = t.slice(barra + 1).replace(/\//g, '').slice(0, 3);
    return sis ? sis + '/' + dia : '';
  }
  const dig = t.slice(0, 6);
  const nSis = dig[0] === '1' || dig[0] === '2' ? 3 : 2;      // 100–299 tiene 3 cifras; 50–99, 2
  if (dig.length < nSis) return dig;
  if (dig.length === nSis) return borrando ? dig : dig + '/';
  return dig.slice(0, nSis) + '/' + dig.slice(nSis, nSis + 3);
}

/** Devuelve el texto ya formateado. `previo` sirve para dejar borrar la barra de la presión. */
export function mascara(clave, nuevo, previo = '') {
  const borrando = String(nuevo == null ? '' : nuevo).length < String(previo == null ? '' : previo).length;
  switch (clave) {
    case 'temperatura': {
      const t = String(nuevo == null ? '' : nuevo).replace(',', '.');
      if (!t.includes('.') && /^\d{3,}$/.test(t) && !borrando) return decimal(t.slice(0, 2) + '.' + t.slice(2), 2, 1);   // 365 → 36.5
      return decimal(t, 2, 1);
    }
    case 'pa': return presion(nuevo, previo, borrando);
    case 'fc': case 'spo2': return soloDigitos(nuevo, 3);
    case 'fr': return soloDigitos(nuevo, 2);
    case 'talla': return soloDigitos(nuevo, 3);
    case 'peso': case 'perimetro': return decimal(nuevo, 3, 1);
    default: return String(nuevo == null ? '' : nuevo);
  }
}

/** Mensaje si el valor está fuera de lo posible (el servidor no lo aceptaría); '' si está bien o vacío. */
export function errorVital(clave, valor) {
  const v = String(valor == null ? '' : valor);
  if (!v) return '';
  if (clave === 'pa') {
    const m = /^(\d{2,3})\/(\d{2,3})$/.exec(v);
    if (!m) return /\/$/.test(v) || /^\d{1,3}$/.test(v) || /^\d{2,3}\/\d?$/.test(v) ? '' : 'Use el formato 120/80.';
    const s = +m[1], d = +m[2];
    if (s < PA_LIMITES.sis[0] || s > PA_LIMITES.sis[1] || d < PA_LIMITES.dia[0] || d > PA_LIMITES.dia[1] || d >= s) return 'Presión arterial: use 120/80 (la sistólica debe ser mayor que la diastólica).';
    return '';
  }
  const r = RANGOS[clave]; if (!r) return '';
  const n = parseFloat(v);
  if (isNaN(n)) return '';
  return n < r[0] || n > r[1] ? r[2] : '';
}

/** Semáforo referencial en adultos. nivel: ok | bajo | alto | ojo (límite) | critico. */
export function semaforo(clave, valor, ctx = {}) {
  const v = String(valor == null ? '' : valor);
  if (!v || errorVital(clave, v)) return null;
  if (clave === 'pa') {
    const m = /^(\d{2,3})\/(\d{2,3})$/.exec(v); if (!m) return null;
    const s = +m[1], d = +m[2];
    if (s < 90 || d < 60) return { nivel: 'bajo', texto: 'Baja' };
    if (s >= 140 || d >= 90) return { nivel: 'alto', texto: 'Alta' };
    if (s >= 120 || d >= 80) return { nivel: 'ojo', texto: 'Elevada' };
    return { nivel: 'ok', texto: 'Normal' };
  }
  const n = parseFloat(v); if (isNaN(n)) return null;
  switch (clave) {
    case 'temperatura': return n < 36 ? { nivel: 'bajo', texto: 'Baja' } : n > 37.5 ? { nivel: 'alto', texto: 'Elevada' } : { nivel: 'ok', texto: 'Normal' };
    case 'fc': return n < 60 ? { nivel: 'bajo', texto: 'Baja' } : n > 100 ? { nivel: 'alto', texto: 'Alta' } : { nivel: 'ok', texto: 'Normal' };
    case 'fr': return n < 12 ? { nivel: 'bajo', texto: 'Baja' } : n > 20 ? { nivel: 'alto', texto: 'Alta' } : { nivel: 'ok', texto: 'Normal' };
    case 'spo2': return n < 90 ? { nivel: 'critico', texto: 'Muy baja' } : n < 95 ? { nivel: 'bajo', texto: 'Baja' } : { nivel: 'ok', texto: 'Normal' };
    case 'perimetro': {
      const lim = ctx.sexo === 'M' ? 88 : ctx.sexo === 'H' ? 102 : null;
      if (!lim) return null;
      return n >= lim ? { nivel: 'alto', texto: 'Riesgo aumentado' } : { nivel: 'ok', texto: 'Normal' };
    }
    default: return null;
  }
}

/** Clasificación del IMC (OMS, adultos) y posición 0–100 en la barra de 15 a 40. */
export function claseImc(imc) {
  if (imc == null || isNaN(imc)) return null;
  const pos = Math.max(0, Math.min(100, ((imc - 15) / 25) * 100));
  if (imc < 18.5) return { nivel: 'bajo', texto: 'Bajo peso', pos };
  if (imc < 25) return { nivel: 'ok', texto: 'Normal', pos };
  if (imc < 30) return { nivel: 'ojo', texto: 'Sobrepeso', pos };
  if (imc < 35) return { nivel: 'alto', texto: 'Obesidad grado I', pos };
  if (imc < 40) return { nivel: 'alto', texto: 'Obesidad grado II', pos };
  return { nivel: 'critico', texto: 'Obesidad grado III', pos };
}

/** Código CIE-10 mientras se escribe: mayúsculas, letra + 2 dígitos + punto + 1 dígito (M545 → M54.5). */
export function mascaraCie(t) {
  const s = String(t == null ? '' : t).toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!s) return '';
  const l = /^[A-Z]/.test(s) ? s[0] : '';
  if (!l) return '';                                   // el código empieza siempre con una letra
  const nums = s.slice(1).replace(/\D/g, '').slice(0, 3);
  return nums.length > 2 ? l + nums.slice(0, 2) + '.' + nums.slice(2) : l + nums;
}
export const CIE_FRECUENTES = ['Z10.0', 'Z00.0', 'M54.5', 'H52.4', 'I10'];
export const CIE_RE = /^[A-Z]\d{2}(\.\d)?$/;
